import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { SettingGroup } from '../../../models/setting-group';
import { SettingType } from '../../../models/setting-type';

import { AlertService } from '../../../services/common/alert.service';
import { SettingTypeService } from '../../../services/settings/setting-type.service';

declare var swal: any;

@Component({
  selector: 'app-setting-type-index',
  templateUrl: './setting-type-index.component.html',
  styleUrls: ['./setting-type-index.component.css'],
})
export class SettingTypeIndexComponent implements OnInit, OnChanges {
  @Input() settingGroup: SettingGroup;

  settingTypes: Array<SettingType> = [];
  addingSettingType: boolean = false;
  newSettingType: SettingType = new SettingType();
  editingSettingTypes: any = {};

  constructor(private alertService: AlertService, private settingTypeService: SettingTypeService) {}

  ngOnInit() {
    if (this.settingGroup) {
      this.settingTypeService.getSettingTypes(this.settingGroup.id, {}).then((response_json) => {
        this.settingTypes = response_json;
      });
      this.newSettingType.setting_group_id = this.settingGroup.id;
    }
  }

  ngOnChanges(changes: any) {
    if (changes.settingGroup && changes.settingGroup.currentValue) {
      this.settingTypeService.getSettingTypes(this.settingGroup.id, {}).then((response_json) => {
        this.settingTypes = response_json;
      });
      this.newSettingType.setting_group_id = this.settingGroup.id;
    }
  }
  onSettingTypeFormEvent(formResult: string, settingType: SettingType | undefined = undefined) {
    switch (formResult) {
      case 'Form Cancelled':
        if (settingType) this.editingSettingTypes[settingType.id] = false;
        else {
          this.addingSettingType = false;
          this.newSettingType = new SettingType();
          this.newSettingType.setting_group_id = this.settingGroup.id;
        }
        break;
      case 'Setting Type created':
        this.addingSettingType = false;
        this.newSettingType = new SettingType();
        this.newSettingType.setting_group_id = this.settingGroup.id;
        this.settingTypeService.getSettingTypes(this.settingGroup.id, {}).then((response_json) => {
          this.settingTypes = response_json;
        });
        break;
      case 'Setting Type updated':
        if (settingType) {
          this.editingSettingTypes[settingType.id] = false;
          this.settingTypeService.getSettingTypes(this.settingGroup.id, {}).then((response_json) => {
            this.settingTypes = response_json;
          });
        }
        break;
    }
  }

  deleteSettingType(settingType: SettingType) {
    let scope: SettingTypeIndexComponent = this;
    swal({
      title: 'Delete setting',
      text: `Delete - ${settingType.name} ?`,
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {
          text: 'No',
          value: false,
          visible: true,
          className: '',
          closeModal: true,
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: '',
          closeModal: true,
        },
      },
    })
      .then((confirmed: any) => {
        if (confirmed)
          this.settingTypeService
            .deleteSettingType(settingType.id)
            .then((response) => {
              if (response && response.text) {
                this.alertService.alert_status_success(response.text);
                this.settingTypeService.getSettingTypes(this.settingGroup.id, {}).then((response_json) => {
                  this.settingTypes = response_json;
                });
              } else {
                this.alertService.alert_status_danger('Error deleting setting type');
              }
            })
            .catch(function () {
              scope.alertService.alert_status_danger('Error deleting setting type');
            });
      })
      .catch((err: any) => {
        console.log('Setting prompt error', err);
      });
  }

  toggleForm() {
    this.addingSettingType = !this.addingSettingType;
    this.newSettingType = new SettingType();
    this.newSettingType.setting_group_id = this.settingGroup.id;
  }
}
